type NotesModalCallback = (analysisId: string) => void;
type NotesReadCallback = (analysisId: string) => void;

class NotesModalService {
  private listeners: NotesModalCallback[] = [];
  private readListeners: NotesReadCallback[] = [];

  open(analysisId: string) {
    for (const cb of this.listeners) {
      cb(analysisId);
    }
  }

  subscribe(cb: NotesModalCallback): () => void {
    this.listeners.push(cb);
    return () => {
      this.listeners = this.listeners.filter(l => l !== cb);
    };
  }

  /** Notifies subscribers that the notes of an analysis have just been read by the current user. */
  notifyRead(analysisId: string) {
    for (const cb of this.readListeners) {
      cb(analysisId);
    }
  }

  subscribeRead(cb: NotesReadCallback): () => void {
    this.readListeners.push(cb);
    return () => {
      this.readListeners = this.readListeners.filter(l => l !== cb);
    };
  }
}

export const notesModalService = new NotesModalService();
